var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "reference-clients-actions" },
    [
      _c("c-button", {
        directives: [
          {
            name: "b-popover",
            rawName: "v-b-popover.html",
            value: {
              container: "#app",
              trigger: "hover blur",
              content: _vm.record.isWorker
                ? "Снять метку сотрудника"
                : "Отметить клиента как сотрудника",
              placement: "top",
            },
            expression:
              "{\n      container: '#app',\n      trigger: 'hover blur',\n      content: record.isWorker ? 'Снять метку сотрудника' : 'Отметить клиента как сотрудника',\n      placement: 'top',\n    }",
            modifiers: { html: true },
          },
        ],
        staticClass: "reference-clients-actions-mark-as-employee",
        attrs: {
          size: "iconic",
          icon: _vm.record.isWorker ? "unmark-employee" : "mark-as-employee",
        },
        on: { click: _vm.changeCustomerTypeRequest },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }